<nb-alert *ngIf="error" outline="danger" role="alert" class="twofa-alert">
  {{ error }}
</nb-alert>

<!-- ── Overview (settings page only) ─────────────────────────────── -->
<ng-container *ngIf="!forced && stage === 'overview'">
  <div class="twofa-status" *ngIf="status">
    <nb-icon
      [icon]="status.enabled ? 'shield' : 'shield-off-outline'"
      [status]="status.enabled ? 'success' : 'basic'"
    ></nb-icon>
    <div>
      <p class="twofa-state">
        {{ status.enabled ? ('pages.twofa.on' | translate) : ('pages.twofa.off' | translate) }}
      </p>
      <p class="caption" *ngIf="status.enabled">
        {{ 'pages.twofa.recoveryLeft' | translate: { count: status.recovery_codes_remaining } }}
      </p>
      <p class="caption" *ngIf="!status.enabled && status.required">
        {{ requiredHintKey | translate }}
      </p>
    </div>
  </div>

  <!-- One switch for the whole thing. "Off" is not an opt-out: if the
       organisation requires a factor, the next sign-in leads straight back
       into setup - which is also how you move to a new phone. -->
  <div class="twofa-toggle" *ngIf="status && !disabling">
    <nb-toggle
      [checked]="status.enabled"
      [disabled]="busy"
      (checkedChange)="onToggle($event)"
    >
      {{ 'pages.twofa.toggleLabel' | translate }}
    </nb-toggle>
    <p class="caption" *ngIf="status.enabled && status.required">
      {{ reenrolHintKey | translate }}
    </p>
  </div>

  <div class="twofa-actions" *ngIf="status?.enabled && !disabling">
    <div class="twofa-inline">
      <input nbInput fieldSize="small" [(ngModel)]="code" name="regen_code"
             inputmode="numeric" maxlength="7"
             [placeholder]="'pages.twofa.codePlaceholder' | translate" />
      <button nbButton status="basic" size="small" [disabled]="busy || !code"
              (click)="regenerate()">
        {{ 'pages.twofa.newRecoveryCodes' | translate }}
      </button>
    </div>
  </div>

  <!-- Disable needs password AND a current code: a stolen session alone must
       not be able to strip the factor. -->
  <div class="twofa-disable" *ngIf="disabling">
    <p class="caption">{{ 'pages.twofa.disableHint' | translate }}</p>
    <input nbInput fullWidth fieldSize="small" type="password"
           [(ngModel)]="disablePassword" name="disable_password"
           [placeholder]="'pages.twofa.passwordPlaceholder' | translate" />
    <input nbInput fullWidth fieldSize="small" [(ngModel)]="disableCode"
           name="disable_code" inputmode="numeric" maxlength="7"
           [placeholder]="'pages.twofa.codePlaceholder' | translate" />
    <div class="twofa-actions">
      <button nbButton status="basic" class="btn-caution" size="small"
              [disabled]="busy || !disablePassword || !disableCode"
              (click)="confirmDisable()">
        {{ 'pages.twofa.disableConfirm' | translate }}
      </button>
      <button nbButton status="basic" size="small" [disabled]="busy"
              (click)="cancelDisable()">
        {{ 'buttons.cancel' | translate }}
      </button>
    </div>
  </div>
</ng-container>

<!-- ── Scan ──────────────────────────────────────────────────────── -->
<ng-container *ngIf="stage === 'scan'">
  <p class="caption">{{ 'pages.twofa.scanHint' | translate }}</p>

  <div class="twofa-qr" *ngIf="qr" [innerHTML]="qr"></div>

  <p class="caption twofa-secret">
    {{ 'pages.twofa.manualEntry' | translate }} <code>{{ secret }}</code>
  </p>

  <div class="twofa-inline">
    <input nbInput fieldSize="small" [(ngModel)]="code" name="activate_code"
           inputmode="numeric" maxlength="7" autocomplete="one-time-code"
           [placeholder]="'pages.twofa.codePlaceholder' | translate" />
    <button nbButton status="primary" size="small" [disabled]="busy || !code"
            (click)="activate()">
      {{ 'pages.twofa.activate' | translate }}
    </button>
  </div>
</ng-container>

<!-- ── Recovery codes: the one and only time they are readable ───── -->
<ng-container *ngIf="stage === 'codes'">
  <nb-alert outline="warning" role="alert">
    {{ 'pages.twofa.codesWarning' | translate }}
  </nb-alert>

  <ul class="twofa-codes">
    <li *ngFor="let rc of recoveryCodes"><code>{{ rc }}</code></li>
  </ul>

  <div class="twofa-actions">
    <button nbButton status="basic" size="small" (click)="copyCodes()">
      {{ 'buttons.copy' | translate }}
    </button>
    <button nbButton status="basic" size="small" (click)="downloadCodes()">
      {{ 'buttons.download' | translate }}
    </button>
  </div>

  <nb-checkbox [(ngModel)]="codesAcknowledged" name="codes_ack">
    {{ 'pages.twofa.codesAck' | translate }}
  </nb-checkbox>

  <div class="twofa-actions">
    <button nbButton status="primary" size="small" [disabled]="!codesAcknowledged"
            (click)="finishCodes()">
      {{ 'pages.twofa.done' | translate }}
    </button>
  </div>
</ng-container>

<p *ngIf="stage === 'loading'" class="caption">{{ 'pages.twofa.loading' | translate }}</p>
